/**
 * Generate customer ID from customer name
 */
export function generateCustomerId(customerName) {
  return customerName
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
